
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinvimannagar() {



    const cardData =
    {
        keyword: 'Corporate Cab Service in Viman Nagar ',
        heading: 'etravo : Corporate Cab Service in Viman Nagar',
"title": "Corporate Cab Service in Viman Nagar",

"headingDescription": "eTravo provides reliable Corporate Cab Service in Viman Nagar, Pune, tailored for businesses, executives, and IT professionals seeking punctual and comfortable travel. Whether it’s airport transfers, employee transportation, client meetings, or corporate events, eTravo offers chauffeur-driven sedans, SUVs, and premium vehicles with flexible hourly and monthly plans—ensuring seamless business mobility in and around Viman Nagar.",

"top": "Top Corporate Cab Services in Viman Nagar with eTravo",

"topPlaces": [
  {
    "title": "Viman Nagar Business Hub",
    "description": "Viman Nagar is one of Pune’s प्रमुख corporate zones, located near the airport and home to multiple IT offices, business centers, and hotels—making it ideal for executive travel and airport transfers."
  },
  {
    "title": "Pune Airport Area",
    "description": "The proximity to Pune International Airport makes this area a high-demand zone for corporate cab services, especially for frequent business travelers and client pickups."
  },
  {
    "title": "EON IT Park Connectivity",
    "description": "Viman Nagar provides quick access to EON IT Park in Kharadi, making it a preferred location for IT professionals and corporate commute services."
  },
  {
    "title": "Koregaon Park Access",
    "description": "Located close to Koregaon Park, Viman Nagar is ideal for executives attending meetings, conferences, and business events in premium business spaces."
  },
  {
    "title": "Kalyani Nagar Business District",
    "description": "A nearby corporate hub with offices, co-working spaces, and commercial establishments, requiring reliable daily corporate transportation."
  },
  {
    "title": "Yerwada Corporate Zone",
    "description": "Yerwada hosts several corporate offices and is well-connected to Viman Nagar, making it a key route for employee transport services."
  },
  {
    "title": "Airport Road Corridor",
    "description": "This stretch connects major corporate and commercial areas, making it a crucial route for business travel and corporate cab operations."
  },
  {
    "title": "Business Hotels in Viman Nagar",
    "description": "The area is filled with business hotels and conference venues, increasing demand for professional chauffeur-driven corporate cab services."
  },
  {
    "title": "Phoenix Marketcity Area",
    "description": "A commercial hotspot combining retail and business activities, often used for corporate meetings and informal business gatherings."
  },
  {
    "title": "Ramwadi Metro Connectivity",
    "description": "With metro connectivity improving access, Viman Nagar continues to grow as a corporate travel hub requiring efficient cab services."
  }
],


"services": [
{
"name": "Corporate Cab Viman Nagar",
"description": "eTravo offers reliable corporate cab services in Viman Nagar designed for smooth and professional business travel. Whether it’s daily office commutes or client visits, our service ensures punctual pickups, comfortable rides, and dependable transportation across Pune’s key corporate areas."
},
{
"name": "Corporate Taxi Viman Nagar Pune",
"description": "Our corporate taxi services in Viman Nagar Pune are tailored for executives and businesses seeking efficient mobility solutions. eTravo provides clean vehicles, trained drivers, and timely service for meetings, airport transfers, and daily corporate travel."
},
{
"name": "Office Cab Viman Nagar",
"description": "Simplify daily commuting with eTravo’s office cab services in Viman Nagar. We offer reliable pickup and drop solutions for employees, ensuring safe, punctual, and hassle-free travel between home and workplace."
},
{
"name": "Business Cab Service Viman Nagar",
"description": "eTravo’s business cab service in Viman Nagar is ideal for professionals who require dependable travel for meetings and corporate activities. Our service focuses on comfort, punctuality, and a smooth travel experience."
},
{
"name": "Company Cab Hire Viman Nagar",
"description": "eTravo provides company cab hire in Viman Nagar with customized solutions for organizations. From employee transport to executive travel, our services ensure flexibility, reliability, and professional travel management."
},
{
"name": "Employee Transport Viman Nagar",
"description": "Our employee transport services in Viman Nagar are designed to ensure safe and efficient daily commutes. eTravo offers well-planned routes, punctual service, and comfortable vehicles for workforce mobility."
},
{
"name": "Corporate Travel Cab Viman Nagar",
"description": "eTravo’s corporate travel cab services in Viman Nagar provide seamless transportation for business needs. Whether it’s local travel or outstation trips, our services ensure comfort and timely arrivals."
},
{
"name": "Professional Taxi Viman Nagar Pune",
"description": "Experience high-quality travel with eTravo’s professional taxi services in Viman Nagar Pune. Our trained chauffeurs and well-maintained cars ensure a reliable and comfortable journey for corporate clients."
},
{
"name": "Staff Cab Service Viman Nagar",
"description": "eTravo offers dependable staff cab services in Viman Nagar for daily employee transport. Our services ensure punctual pickups, safe rides, and smooth travel coordination for organizations."
},
{
"name": "Corporate Pickup Drop Viman Nagar",
"description": "Our corporate pickup and drop services in Viman Nagar are designed for efficient employee commuting. eTravo ensures timely scheduling, route optimization, and comfortable rides for daily office travel."
},
{
"name": "Executive Cab Viman Nagar",
"description": "eTravo provides executive cab services in Viman Nagar for senior management and VIP clients. Our premium vehicles offer comfort, privacy, and professional service for meetings, airport transfers, and business travel."
},
{
"name": "Corporate Fleet Viman Nagar",
"description": "eTravo offers corporate fleet services in Viman Nagar for businesses that require multiple vehicles. Our fleet solutions ensure consistent availability, proper maintenance, and smooth operations for daily transportation."
},
{
"name": "Office Transport Viman Nagar",
"description": "Streamline office travel with eTravo’s office transport services in Viman Nagar. We provide efficient and reliable solutions for employee movement between office locations and residential areas."
},
{
"name": "Company Taxi Viman Nagar",
"description": "eTravo’s company taxi services in Viman Nagar provide convenient and flexible transport options for businesses. Whether it’s local travel or urgent bookings, our taxis ensure a smooth and professional experience."
},
{
"name": "Business Travel Cab Viman Nagar",
"description": "For seamless business travel, eTravo offers reliable cab services in Viman Nagar. Our vehicles are designed for comfort and punctuality, helping professionals travel efficiently for meetings and corporate activities."
}
],
"tableData": [
["Corporate Cab Viman Nagar", "Corporate Taxi Viman Nagar Pune"],
["Office Cab Viman Nagar", "Business Cab Service Viman Nagar"],
["Company Cab Hire Viman Nagar", "Employee Transport Viman Nagar"],
["Corporate Travel Cab Viman Nagar", "Professional Taxi Viman Nagar Pune"],
["Staff Cab Service Viman Nagar", "Corporate Pickup Drop Viman Nagar"],
["Executive Cab Viman Nagar", "Corporate Fleet Viman Nagar"],
["Office Transport Viman Nagar", "Company Taxi Viman Nagar"],
["Business Travel Cab Viman Nagar", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Prime Corporate Cab Service in Viman Nagar",
      "WhyChoosedescription": "eTravo offers premium corporate cab service in Viman Nagar, Pune, ensuring smooth and professional transportation for businesses located near IT hubs, corporate offices, and Pune Airport." 
    },
    {
      "WhyChooseheading": "Ideal Location Near Airport and Business Hubs",
      "WhyChoosedescription": "Viman Nagar is a key corporate and residential hub near Pune International Airport, making our cab services perfect for airport transfers, client meetings, and daily office commutes." 
    },
    {
      "WhyChooseheading": "Wide Fleet for Corporate Travel Needs",
      "WhyChoosedescription": "Our fleet includes sedans, SUVs, and executive vehicles suitable for employee transport, business meetings, and VIP travel in and around Viman Nagar." 
    },
    {
      "WhyChooseheading": "Punctual and Reliable Corporate Commute",
      "WhyChoosedescription": "We ensure on-time pickups and drop-offs for corporate employees and executives, helping businesses maintain punctuality and productivity." 
    },
    {
      "WhyChooseheading": "Experienced Chauffeurs with Local Expertise",
      "WhyChoosedescription": "Our drivers are trained and familiar with Viman Nagar routes and surrounding business areas like Kharadi and Koregaon Park, ensuring efficient travel." 
    },
    {
      "WhyChooseheading": "Flexible Corporate Rental Plans",
      "WhyChoosedescription": "eTravo provides customizable plans including daily office transport, monthly rentals, and long-term corporate contracts for companies in Viman Nagar." 
    },
    {
      "WhyChooseheading": "Clean, Safe, and Comfortable Vehicles",
      "WhyChoosedescription": "All vehicles are regularly serviced and sanitized, offering a safe and comfortable travel experience for employees and corporate clients." 
    },
    {
      "WhyChooseheading": "24/7 Corporate Travel Support",
      "WhyChoosedescription": "Our dedicated support team is available round the clock to handle bookings, urgent travel needs, and schedule changes efficiently." 
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is corporate cab service in Viman Nagar?',
            answer: 'Corporate cab service in Viman Nagar includes chauffeur-driven transportation for office commutes, airport transfers, and business meetings for companies located in the area.',
        },
        {
            question: 'Is Viman Nagar a good location for corporate cab services?',
            answer: 'Yes, Viman Nagar is a major business hub near Pune Airport with offices, hotels, and commercial spaces, making it ideal for corporate cab services. :contentReference[oaicite:0]{index=0}',
        },
        {
            question: 'Can I book daily employee transport in Viman Nagar?',
            answer: 'Yes, eTravo offers daily pickup and drop services for employees working in Viman Nagar and nearby corporate hubs.',
        },
        {
            question: 'Do you provide airport transfer services from Viman Nagar?',
            answer: 'Yes, we offer reliable airport pickup and drop services as Viman Nagar is located very close to Pune International Airport. :contentReference[oaicite:1]{index=1}',
        },
        {
            question: 'What types of vehicles are available for corporate use?',
            answer: 'We provide hatchbacks, sedans, SUVs, and luxury cars for corporate travel depending on employee and executive requirements.',
        },
        {
            question: 'Are chauffeurs trained for corporate clients?',
            answer: 'Yes, our chauffeurs are professionally trained to handle corporate travel with proper etiquette, safety, and punctuality.',
        },
        {
            question: 'Can corporate travel plans be customized in Viman Nagar?',
            answer: 'Yes, we offer flexible and customizable travel plans based on business schedules and requirements.',
        },
        {
            question: 'Is the service available 24/7 in Viman Nagar?',
            answer: 'Yes, eTravo provides round-the-clock corporate cab services for businesses operating at any time.',
        },
        {
            question: 'Do you provide GST billing for corporate bookings?',
            answer: 'Yes, we provide GST-compliant invoices for all corporate cab bookings.',
        },
        {
            question: 'How can I book corporate cab service in Viman Nagar?',
            answer: 'You can book through our website or contact our support team for quick and easy corporate travel arrangements.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Ankit Mehta',
        designation: 'Operations Manager, SkyTech Solutions, Viman Nagar',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo provides the best corporate cab service in Viman Nagar. Their punctual pickups and professional drivers make daily office travel hassle-free.”',
    },
    {
        name: 'Ms. Richa Verma',
        designation: 'HR Lead, CloudEdge Pvt Ltd, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo for all our corporate travel needs in Viman Nagar. Their flexible plans and reliable service ensure smooth employee transportation.”',
    },
];












    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Viman Nagar",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-viman-nagar.jpg",
  "description": "Professional corporate cab services in Viman Nagar, Pune by eTravo. Ideal for employee transport, office pickup and drop, business travel, and executive cab hire with reliable and comfortable service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-service-in-viman-nagar"
  }
};





    return (
        <div>


<Helmet>
  <title>Corporate Cab Service in Viman Nagar | Office & Business Travel Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab service in Viman Nagar, Pune with eTravo for employee transport, office pickup and drop, executive rides, and business travel needs. Safe and reliable service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/124.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinvimannagar;